<div class="error-msg-wrapper padding-top-5">
	<icon type="exclamation-triangle"></icon> <span class="error text-12" [dcrHTMLKey]="errorDcrKey">Please enter a valid amount.</span>
</div>
